import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fd44cf1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "navbar" }
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = ["onClick", "textContent"]
const _hoisted_5 = { class: "main-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fm_audio = _resolveComponent("fm-audio")!
  const _component_fm_read = _resolveComponent("fm-read")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(['tab', _ctx.currentTab === index && 'active']),
            onClick: ($event: any) => (_ctx.currentTab = index),
            textContent: _toDisplayString(item)
          }, null, 10, _hoisted_4))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createVNode(_component_fm_audio, {
        modelValue: _ctx.audioCurrentSlider,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.audioCurrentSlider) = $event)),
        audioDuration: _ctx.audioDuration,
        audioCurrentTime: _ctx.audioCurrentTime,
        isPaused: _ctx.isPaused,
        audioDetail: _ctx.audioDetail,
        onOnChangeCurrentTime: _ctx.onChangeCurrentTime,
        onChangePlayStatus: _ctx.changePlayStatus
      }, null, 8, ["modelValue", "audioDuration", "audioCurrentTime", "isPaused", "audioDetail", "onOnChangeCurrentTime", "onChangePlayStatus"]), [
        [_vShow, _ctx.currentTab === 0]
      ]),
      _withDirectives(_createVNode(_component_fm_read, { audioDetail: _ctx.audioDetail }, null, 8, ["audioDetail"]), [
        [_vShow, _ctx.currentTab === 1]
      ])
    ])
  ]))
}